// Shared crop styling for a vehicle_photos row.
//
// object-position (focal_x/focal_y) only PANS within whatever overflow
// object-fit: cover already produces — if the photo's aspect ratio is close
// to the card's, there's almost no overflow to pan across, so repositioning
// does very little for a photo where the car is small and far away in the
// frame. The extra `transform: scale()` (zoom) fixes that: it magnifies the
// image around the same focal point, so a distant car can actually be made
// to fill the crop, not just shifted around inside it.
//
// zoom < 1 is "zoom out": object-fit switches from cover to contain, so the
// WHOLE photo becomes visible (letterboxed, no cropping) instead of the
// tightly-cropped cover view — useful when cover was cutting off part of
// the car (e.g. the roof or a bumper) because the photo's aspect ratio
// didn't match the card's. Zooming out further just shrinks that already
// uncropped photo a bit more inside the frame.
export const cropStyle = (photo) => {
  const fx = photo?.focal_x ?? 50;
  const fy = photo?.focal_y ?? 50;
  const zoom = Number(photo?.zoom) || 1;
  return {
    objectFit: zoom < 1 ? 'contain' : 'cover',
    objectPosition: `${fx}% ${fy}%`,
    transform: zoom !== 1 ? `scale(${zoom})` : undefined,
    transformOrigin: `${fx}% ${fy}%`,
  };
};
